export function getdata() {
	var obj = {
		formlist: [{
			prop: 'accessUnitNaturalId',
			label: '接入单位乐企ID',
			type: 'input',
			width: "220px",

		}, {
			prop: 'useCaseCoding',
			label: '用例编码',
			type: 'input',
			width: "220px"
		}, {
			prop: 'accessSignature',
			label: '签名加密串',
			type: 'input',
			width: "220px"
		}, {
			prop: 'useUnitNaturalId',
			label: '使用单位乐企ID',
			type: 'input',
			width: "220px"
		}, {
			prop: 'sandboxTestMark',
			label: '沙箱测试标志',
			type: 'input',
			width: "220px"
		}],
		formdata: {
			accessUnitNaturalId: "",
			useCaseCoding: "",
			accessSignature: "",
			useUnitNaturalId: "",
			sandboxTestMark: "",
		},
		options: [{
			value: '中华人民共和国',
			label: '中华人民共和国'
		}, {
			value: '中国台湾',
			label: '中国台湾'
		}, {
			value: '中国香港特别行政区',
			label: '中国香港特别行政区'
		}, {
			value: '中国澳门特别行政区',
			label: '中国澳门特别行政区'
		}],
		zhengjlx: [{
			value: '4',
			label: '居民身份证'
		}, {
			value: '0',
			label: '组织机构代码'
		}, {
			value: '1',
			label: '营业执照'
		}, {
			value: '2',
			label: '税务登记证'
		}, {
			value: '3',
			label: '其他单位证件'
		}],



		rpaFormList:[
			{
				prop: 'loginAccount',
				label: '税局用户名',
				type: 'input',
				width: "220px",
				isnotnull: true,
			},
			{
				prop: 'loginPassword',
				label: '登录密码',
				type: 'input',
				width: "220px",
				ispassword:true,
				isnotnull: true,
			},
			{
				prop: 'diskNo',
				label: '税盘编号',
				type: 'select',
				width: "220px",
				disabled:true,
				isnotnull: false,
				selectval: []
			},
			{
				prop: 'clientId',
				label: '商户编码',
				type: 'input',
				width: "220px",
				isnotnull: true,
			},
			{
				prop: 'loginIdentities',
				label: '登录身份',
				type: 'select',
				width: "220px",
				isnotnull: true,
				selectval: [
					{
						label: '开票员',
						value: '1'
					},
					{
						label: '法定代表人',
						value: '2'
					},
					{
						label: '财务负责人',
						value: '3'
					},
					{
						label: '办税员',
						value: '4'
					},
					{
						label: '管理员',
						value: '5'
					},
					{
						label: '领票员',
						value: '6'
					},
					{
						label: '社保经办人',
						value: '7'
					}
				],
			},
			{
				prop: 'loginWay',
				label: '登录方式',
				type: 'radio',
				isnotnull: true,
				radioval:[
					{
						label:"税盘登录",
						value:"1"
					},
					{
						label:"数字证书",
						value:"2"
					},
					{
						label:"手机短信",
						value:"3"
					},
				]
				// slot: true
			},

			{
				prop: 'clientSecret',
				label: '商户密钥',
				type: 'input',
				width: "220px",
				isnotnull: true,
			},

		],
		rpaformdata: {
			loginAccount: "",
			loginPassword: "",
			loginIdentities: "",
			loginWay: "",
			diskNo: "",
			clientId: "",
			clientSecret: "",
		},
	}
	return obj
}
